import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { Table } from "elemental-react16"
import Price from "components/Price/Price"
import { observer } from "mobx-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore";
import CouponInput  from "components/Cart/CouponInput";
import { withRouter, Link } from "react-router-dom"
import { act } from "react"
import Responsive from "react-responsive"

@observer
class CartTotal extends Component {
  
  componentDidMount() {
    shop.cart.update()
  }
  
  render() {
    let { sum, size, showTax, fluid, className = "", activeStep } = this.props
    let {  brutto, sumDiscount } = shop.cart
    let tax = shop.cart.data.vat
    let discountSum = shop.cart.data.sum
    let discountVat = shop.cart.data.vat
    console.log("SHOP:::CART", shop.cart,"discountSum",discountSum, "discountVat",discountVat, "OG brutto",brutto, "OG tax",tax, "OG sum",sum)
    let couponsActivated = shop.cart.activeCoupons && shop.cart.activeCoupons[0]

    if (tax === 0){
      tax = sum * 0.19
      brutto = sum + tax
    }
    let noCouponPrice = 0
    if(shop.cart.data.positions && shop.cart.activeCoupons.length > 0){
      shop.cart.data.positions.map( position => {
        console.log("noCouponPrice position",position, position.extras && position.extras.couponPrice , position.count , position.unit_multi)
        const couponPrice = position.extras && position.extras.brutto != null && position.extras.brutto !== "" ? position.extras.brutto : position.extras && position.extras.couponPrice;
        noCouponPrice += Number(parseFloat(couponPrice) * position.count * position.unit_multi);
      } )

    }
    if(couponsActivated && activeStep !== 3){
      tax = noCouponPrice * 0.19
      brutto = noCouponPrice + tax
      console.log("recalculated brutto and tax with coupons", brutto, tax, noCouponPrice)
    }
    shop.cart.setExtra("noCouponPrice",!isNaN(noCouponPrice)  ? noCouponPrice : 0)
    shop.cart.setExtra("couponCode",shop.cart.data && shop.cart.data.giftcards && shop.cart.data.giftcards[0] ? shop.cart.data.giftcards[0]  : "")
    console.log("noCouponPrice",noCouponPrice, sum, shop.cart.data, shop.cart.activeCoupons)
    console.log("fluid",fluid, "brutto",brutto, "tax",tax, "sumDiscount",sumDiscount, "sum",sum, "size",size, "activeStep",activeStep, shop.cart.data, shop.cart.activeCoupons[0])
    return (<Fragment>
      {/*<div className="flex flex-column items-center justify-between mb3 w-100">
        {cmsStore.config.plugin.coupons && (activeStep === 0 || activeStep === 100) &&
         <CouponInput/>}

      </div> */}
      <div className="CartTotalContainer">
          {activeStep == 0 && <div className="cartTotalFooter pb3"><CouponInput/></div>}
          <div className="cartTotalFooter flex flex-row justify-between w-100">
            <p>{translate( "Positionen:" )}</p>
            <p>{size}</p>
          </div>
          <div className="cartTotalFooter flex flex-row justify-between w-100">
            <p>{translate( "cartfooter.nettosum" )}</p>
            <p>{couponsActivated && activeStep !== 3 ? <Fragment>
              <span className="strike black-60"><Price>{activeStep == 99 ? brutto - tax : noCouponPrice}</Price></span><br/>
              <span className="red fw6 tr"><Price>{activeStep == 99 ? brutto - tax : discountSum}</Price></span></Fragment> : <Price>{activeStep == 99 ? brutto - tax : sum}</Price>}</p>
          </div>
          <div className="cartTotalFooter flex flex-row justify-between w-100">
            <p>{translate( "cartfooter.addvat" )}</p>
            <p>{couponsActivated && activeStep !== 3 ? <Fragment><span className="strike black-60"><Price>{tax}</Price></span><br/>
            <span className="red fw6 tr"><Price>{discountVat}</Price></span></Fragment> : <Price>{tax}</Price>}</p>
          </div>
          <div className="cartTotalFooter flex flex-row justify-between w-100">
            <p>{translate( "cartfooter.bruttosum" )}</p>
            <p>{couponsActivated && activeStep !== 3 ? <Fragment>
              <span className="strike black-60"><Price>{activeStep == 99 ? brutto : Number(brutto)}</Price></span><br/>
              <span className="red fw6 tr"><Price>{activeStep == 99 ? brutto : Number(discountSum)+Number(discountVat)}</Price></span></Fragment> : 
              <Price>{activeStep == 99 ? brutto : Number(sum)+Number(tax)}</Price>}</p>
          </div>
      </div>

      </Fragment>
    )
  }
}

CartTotal.propTypes = {
  sum : PropTypes.number,
  size: PropTypes.number,
}

export default CartTotal



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Cart/CartTotal.js